import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Api_version_bs$SolvuuApi0 from "./api_version_bs.bs.js";
import * as Http_version_bs$SolvuuApi0 from "./http_version_bs.bs.js";

function write_info(write__ok, write__bad_request, write__not_found) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant !== -99004555) {
      if (variant >= 17692) {
        return Atdgen_codec_runtime.Encode.constr1("OK", write__ok, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Not_found", write__not_found, x[1]);
      }
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Bad_request", write__bad_request, x[1]);
    }
  });
}

function read_info(read__ok, read__bad_request, read__not_found) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["OK",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `OK */
        [17692, x]
      );
    }, read__ok, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Bad_request",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Bad_request */
        [-99004555, x]
      );
    }, read__bad_request, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Not_found",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Not_found */
        [-358247754, x]
      );
    }, read__not_found, param);
  }]],
  /* [] */
  0]]]);
}

function write_t(write__ok, write__bad_request, write__not_found) {
  return Atdgen_codec_runtime.Encode.make(function (t) {
    return Atdgen_codec_runtime.Encode.obj(
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Api_version_bs$SolvuuApi0.write_t, "api_version", t.api_version),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, Http_version_bs$SolvuuApi0.write_t, "http_version", t.http_version),
    /* :: */
    [Atdgen_codec_runtime.Encode.field(undefined, write_info(write__ok, write__bad_request, write__not_found), "info", t.info),
    /* [] */
    0]]]);
  });
}

function read_t(read__ok, read__bad_request, read__not_found) {
  return Atdgen_codec_runtime.Decode.make(function (json) {
    var partial_arg = read_info(read__ok, read__bad_request, read__not_found);
    return {
      api_version: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("api_version", Api_version_bs$SolvuuApi0.read_t, param);
      }, json),
      http_version: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("http_version", Http_version_bs$SolvuuApi0.read_t, param);
      }, json),
      info: Atdgen_codec_runtime.Decode.decode(function (param) {
        return Atdgen_codec_runtime.Decode.field("info", partial_arg, param);
      }, json)
    };
  });
}

function write_success(write__ok) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    return Atdgen_codec_runtime.Encode.constr1("OK", write__ok, x[1]);
  });
}

function read_success(read__ok) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["OK",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `OK */
        [17692, x]
      );
    }, read__ok, param);
  }]],
  /* [] */
  0]);
}

function write_client_error(write__bad_request, write__not_found) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= -99004555) {
      return Atdgen_codec_runtime.Encode.constr1("Bad_request", write__bad_request, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Not_found", write__not_found, x[1]);
    }
  });
}

function read_client_error(read__bad_request, read__not_found) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Bad_request",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Bad_request */
        [-99004555, x]
      );
    }, read__bad_request, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Not_found",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Not_found */
        [-358247754, x]
      );
    }, read__not_found, param);
  }]],
  /* [] */
  0]]);
}

var read_http_version = Http_version_bs$SolvuuApi0.read_t;
var write_http_version = Http_version_bs$SolvuuApi0.write_t;
var read_api_version = Api_version_bs$SolvuuApi0.read_t;
var write_api_version = Api_version_bs$SolvuuApi0.write_t;
export { read_info, write_info, read_http_version, write_http_version, read_api_version, write_api_version, read_t, write_t, read_success, write_success, read_client_error, write_client_error };
/* Api_version_bs-SolvuuApi0 Not a pure module */